import React from "react"
import useInView from "../hooks/useInView.js"

// Wraps children with a fade + lift-in transition triggered when the
// element enters the viewport. delay (ms) lets you stagger siblings.
export default function Reveal({ children, delay = 0, className = "" }) {
  const [ref, inView] = useInView()

  const style = {
    transition: "opacity 700ms cubic-bezier(0.22, 1, 0.36, 1), transform 700ms cubic-bezier(0.22, 1, 0.36, 1)",
    transitionDelay: `${delay}ms`,
    opacity: inView ? 1 : 0,
    transform: inView ? "translateY(0)" : "translateY(16px)",
  }

  return (
    <div ref={ref} style={style} className={className}>
      {children}
    </div>
  )
}
